import react from 'react';
const TableRow = (props) => {
  return <tr className={props.className ? props.className : 'bg-gray-100 '}>{props.children}</tr>;
};
export default TableRow;
